class DateRangePicker {
	static SetStart($field, picker) {
		const value = picker.startDate.format(picker.locale.format);
		$field.val(value).trigger("change");
	}

	static SetValue($field, value) {
		$field.val(value);
		const drp = $field.data("daterangepicker");
		drp.setStartDate(value);
		drp.setEndDate(value);
		$field.trigger("change");
	}

	static SingleDatePicker($field, overrides = {}) {
		const options = $.extend(Defaults.DateRangePickerSingleDateOptions, {
			autoUpdateInput: false
		}, overrides);

		$field.daterangepicker(options);
		$field.on("apply.daterangepicker", (event, picker) => DateRangePicker.SetStart($field, picker));

		// If the field is not empty when the daterangepicker is hidden, populate the field with the formatted value of the selected date
		$field.on("hide.daterangepicker", (event, picker) => {
			if($field.val() !== "" && picker.startDate) {
				DateRangePicker.SetStart($field, picker);
			}
		});

		return $field;
	}

	static SingleDateTimePicker($field, overrides = {}) {
		const options = $.extend(Defaults.DateRangePickerSingleDateTimeOptions, {
			autoUpdateInput: false
		}, overrides);

		$field.daterangepicker(options);
		$field.on("apply.daterangepicker", (event, picker) => DateRangePicker.SetStart($field, picker));

		// If the field is not empty when the daterangepicker is hidden, populate the field with the formatted value of the selected date
		$field.on("hide.daterangepicker", (event, picker) => {
			if($field.val() !== "" && picker.startDate) {
				DateRangePicker.SetStart($field, picker);
			}
		});

		return $field;
	}

	static ApplyDateRangeEvents($field) {
		$field.on("apply.daterangepicker", (event, picker) => {
			const start = picker.startDate.format(picker.locale.format);
			const end = picker.endDate.format(picker.locale.format);
			$field.val(`${start} - ${end}`).trigger("change");
		});

		$field.on("cancel.daterangepicker", () => {
			$field.val("").trigger("change");
		});
	}

	static DateRangePicker($field, options = {}) {
		const pickerOptions = Defaults.DateRangePickerOptions;

		if(options.allowBlank) {
			pickerOptions.autoUpdateInput = false;
		}

		if(typeof options.showCustomRangeLabel !== "undefined") {
			pickerOptions.showCustomRangeLabel = options.showCustomRangeLabel;
		}

		$field.daterangepicker(pickerOptions);

		this.ApplyDateRangeEvents($field);
	}
}
